/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Usage } from "./Usage";
import { UsageFromJSON, UsageFromJSONTyped, UsageToJSON, UsageToJSONTyped } from "./Usage";

/**
 *
 * @export
 * @interface PaginatedUsageList
 */
export interface PaginatedUsageList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<Usage>;
}

/**
 * Check if a given object implements the PaginatedUsageList interface.
 */
export function instanceOfPaginatedUsageList(value: object): value is PaginatedUsageList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedUsageListFromJSON(json: any): PaginatedUsageList {
  return PaginatedUsageListFromJSONTyped(json, false);
}

export function PaginatedUsageListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedUsageList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(UsageFromJSON),
  };
}

export function PaginatedUsageListToJSON(json: any): PaginatedUsageList {
  return PaginatedUsageListToJSONTyped(json, false);
}

export function PaginatedUsageListToJSONTyped(
  value?: PaginatedUsageList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(UsageToJSON),
  };
}
